export { AccessErrorPlaceholderIcon } from './images';
